module.exports = __webpack_public_path__ + "static/media/dialog.64e50e0c.png";